import { isSSR } from '@helpers/ssr';
import { FocusScope } from '@react-aria/focus';
import { AnimatePresence } from 'framer-motion';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Background from './Background/Background';
import Close from './Close/Close';
import { ModalProvider } from './Context/Context';
import S from './Modal.styles';
const Modal = ({ ...props }) => {
    if (isSSR()) {
        return null;
    }
    const innerTransition = { type: 'spring', stiffness: 120, damping: 12 };
    // Use #root if available, otherwise fallback to body.
    const portalContainer = document.getElementById('root') ?? document.body;
    const portalContent = (React.createElement(AnimatePresence, null, props.isOpen && (React.createElement(ModalProvider, { closeOnBackground: props.closeOnBackground, showBackground: props.showBackground, showClose: props.showClose, onClose: props.onClose },
        React.createElement(FocusScope, { autoFocus: true, contain: true, restoreFocus: true },
            React.createElement(S.Container, { id: props.id, key: `modal-${props.id}`, role: "dialog", "aria-label": props.ariaLabel, "aria-modal": "true", onKeyDown: (event) => {
                    if (event.key === 'Escape') {
                        props.onClose();
                    }
                }, "data-open": props.isOpen },
                props.showBackground && React.createElement(Background, null),
                React.createElement(S.Inner, { initial: { y: `33%`, scale: 0.9, opacity: 0 }, animate: {
                        y: `calc(var(--buttonSize) * -1)`,
                        scale: 1,
                        opacity: 1,
                        transition: { ...innerTransition, delay: 0.4 },
                    }, exit: { y: `33%`, scale: 0.9, opacity: 0 }, transition: innerTransition },
                    props.showClose && React.createElement(Close, null),
                    props.children)))))));
    return ReactDOM.createPortal(portalContent, portalContainer);
};
export default Modal;
